export const ORDER_CREATE_REQUEST = 'ORDER_CREATE_REQUEST';
export const ORDER_CREATE_SUCCESS = 'ORDER_CREATE_SUCCESS';
export const ORDER_CREATE_FAIL = 'ORDER_CREATE_FAIL';
export const ORDER_CREATE_RESET = 'ORDER_CREATE_RESET';

export const LIST_ALL_ORDERS_REQUEST = 'LIST_ALL_ORDERS_REQUEST';
export const LIST_ALL_ORDERS_SUCCESS = 'LIST_ALL_ORDERS_SUCCESS';
export const LIST_ALL_ORDERS_FAIL = 'LIST_ALL_ORDERS_FAIL';

export const ORDER_DETAILS_REQUEST = 'ORDER_DETAILS_REQUEST';
export const ORDER_DETAILS_SUCCESS = 'ORDER_DETAILS_SUCCESS';
export const ORDER_DETAILS_FAIL = 'ORDER_DETAILS_FAIL';

export const LIST_MY_ORDERS_REQUEST = 'LIST_MY_ORDERS_REQUEST';
export const LIST_MY_ORDERS_SUCCESS = 'LIST_MY_ORDERS_SUCCESS';
export const LIST_MY_ORDERS_FAIL = 'LIST_MY_ORDERS_FAIL';
export const LIST_MY_ORDERS_RESET = 'LIST_MY_ORDERS_RESET';

export const ORDER_PAY_REQUEST = 'ORDER_PAY_REQUEST';
export const ORDER_PAY_SUCCESS = 'ORDER_PAY_SUCCESS';
export const ORDER_PAY_FAIL = 'ORDER_PAY_FAIL';
export const ORDER_PAY_RESET = 'ORDER_PAY_RESET';

export const ORDER_DELIVER_REQUEST = 'ORDER_DELIVER_REQUEST';
export const ORDER_DELIVER_SUCCESS = 'ORDER_DELIVER_SUCCESS';
export const ORDER_DELIVER_FAIL = 'ORDER_DELIVER_FAIL';
export const ORDER_DELIVER_RESET = 'ORDER_DELIVER_RESET';
